import { useEffect, useState } from 'react';
import { fetchCmsCollection } from '../lib/cms';

const initialState = {
  items: [],
  total: 0,
  loading: true,
  error: null,
};

export default function useCmsCollection(collectionName, options = {}) {
  const [state, setState] = useState(initialState);
  const {
    endpoint = 'v2',
    limit = 25,
    offset = 0,
    sort = 'updatedAt',
    order = 'desc',
    term = [],
  } = options;
  const termParam = Array.isArray(term) ? term.join('|') : '';

  useEffect(() => {
    let active = true;

    async function load() {
      try {
        setState((current) => ({ ...current, loading: true, error: null }));
        const response = await fetchCmsCollection(collectionName, {
          endpoint,
          limit,
          offset,
          sort,
          order,
          term: termParam ? termParam.split('|') : [],
        });

        if (!active) return;

        if (Array.isArray(response)) {
          setState({ items: response, total: response.length, loading: false, error: null });
          return;
        }

        setState({
          items: response.items || [],
          total: response.total || 0,
          loading: false,
          error: null,
        });
      } catch (error) {
        if (!active) return;
        setState({ items: [], total: 0, loading: false, error });
      }
    }

    load();

    return () => {
      active = false;
    };
  }, [collectionName, endpoint, limit, offset, order, sort, termParam]);

  return state;
}
